import { RECORDER_STOP_DATA_WAIT_MS } from './recording.constant'

/**
 * Stop a MediaRecorder and wait for the final dataavailable (including Safari's
 * post-stop delivery) so callers can drain pending upload promises afterward.
 */
export async function waitForMediaRecorderStop(
    recorder: MediaRecorder,
    waitMs: number = RECORDER_STOP_DATA_WAIT_MS
): Promise<void> {
    if (recorder.state === 'inactive') {
        return
    }

    let sawDataAfterFlushRequest = false
    const markData = () => {
        sawDataAfterFlushRequest = true
    }
    recorder.addEventListener('dataavailable', markData)

    try {
        await new Promise<void>((resolve) => {
            recorder.addEventListener('stop', () => resolve(), { once: true })
            try {
                recorder.requestData()
            } catch {
                // already stopping
            }
            recorder.stop()
        })

        // Safari can fire the last dataavailable after stop; wait until it lands or timeout.
        if (!sawDataAfterFlushRequest) {
            await new Promise<void>((resolve) => {
                const timeout = setTimeout(() => {
                    recorder.removeEventListener('dataavailable', onLateData)
                    resolve()
                }, waitMs)
                const onLateData = () => {
                    clearTimeout(timeout)
                    resolve()
                }
                recorder.addEventListener('dataavailable', onLateData, { once: true })
                if (sawDataAfterFlushRequest) {
                    clearTimeout(timeout)
                    recorder.removeEventListener('dataavailable', onLateData)
                    resolve()
                }
            })
        }
        // Let ondataavailable enqueue its upload into pendingUploads.
        await new Promise<void>((resolve) => setTimeout(resolve, 0))
    } finally {
        recorder.removeEventListener('dataavailable', markData)
    }
}
